import React, { Component, useEffect, useState } from "react";
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";

import Home from "./pages/Home/Home";
import AuthLayout from "./pages/Auth/AuthLayout";
import FreeVideos from "./pages/FreeVideos/FreeVideos";
import Courses from "./pages/Courses/Courses";
import CourseDetail from "./pages/Courses/CourseDetail";
import Gallery from "./pages/Gallery/Gallery";
import Contact from "./pages/Contact/Contact";
import About from "./pages/About/About";
import Resources from "./pages/Resources/Resources";
import ScrollToTop from "./components/ScrollToTop";
import Live from "./pages/Live/Live";
import LiveRoom from "./pages/Live/LiveRoom";
import MyPlans from "./pages/Account/MyPlans";
import Library from "./pages/Library/Library";
import Calendar from "./pages/Calendar/Calendar";
import { cachedTenant, resolveTenant } from "./Helper/Api";
import { hasModule } from "./Helper/modules";

// last, so the theme layout blocks layer over the page styles
import "./styles/themes.scss";

/** A page of a feature the tenant category does not have (a gym site has no school lessons) sends the visitor to the home
 *  page instead. Renders nothing for the instant the tenant is still being resolved; once it is, it is cached. */
function ModuleGate({ module, children }) {
  const [allowed, setAllowed] = useState(() => {
    const tenant = cachedTenant();
    return tenant ? hasModule(tenant, module) : null;
  });
  useEffect(() => {
    if (allowed !== null) return;
    resolveTenant().then((tenant) => setAllowed(hasModule(tenant, module))).catch(() => setAllowed(true));
  }, [allowed, module]);
  if (allowed === null) return null;
  return allowed ? children : <Redirect to="/" />;
}

class Connector extends Component {
  render() {
    return (
      <Router>
        {/* inside the Router so it can watch the location, before the Switch
            so it runs on every route change */}
        <ScrollToTop />
        <Switch>
          <Route path="/" exact>
            <Home />
          </Route>
          {/* One route for both, so switching between them swaps only the
              form and leaves the ground, the sheet and the white half mounted */}
          <Route path={["/sign-in", "/sign-up"]} exact component={AuthLayout} />
          <Route path="/free-videos" exact>
            <ModuleGate module="LESSONS">
              <FreeVideos />
            </ModuleGate>
          </Route>
          <Route path="/courses" exact>
            <ModuleGate module="COURSES">
              <Courses />
            </ModuleGate>
          </Route>
          <Route path="/courses/:id">
            <ModuleGate module="COURSES">
              <Route path="/courses/:id" component={CourseDetail} />
            </ModuleGate>
          </Route>
          <Route path="/gallery" exact>
            <ModuleGate module="GALLERY">
              <Gallery />
            </ModuleGate>
          </Route>
          <Route path="/contact" exact>
            <Contact />
          </Route>
          <Route path="/about" exact>
            <About />
          </Route>
          <Route path="/live" exact>
            <ModuleGate module="MEETINGS">
              <Live />
            </ModuleGate>
          </Route>
          <Route path="/live/:id">
            <ModuleGate module="MEETINGS">
              <Route path="/live/:id" component={LiveRoom} />
            </ModuleGate>
          </Route>
          <Route path="/library" exact>
            <ModuleGate module="LIBRARY">
              <Library mode="library" />
            </ModuleGate>
          </Route>
          <Route path="/recipes" exact>
            <ModuleGate module="RECIPES">
              <Library mode="recipes" />
            </ModuleGate>
          </Route>
          <Route path="/calendar" exact>
            <ModuleGate module="CALENDAR">
              <Calendar />
            </ModuleGate>
          </Route>
          <Route path="/account" exact>
            <ModuleGate module="MEMBERSHIPS">
              <MyPlans />
            </ModuleGate>
          </Route>
          <Route path="/resources" exact>
            <ModuleGate module="RESOURCES">
              <Resources />
            </ModuleGate>
          </Route>
        </Switch>
      </Router>
    );
  }
}

export default Connector;
